import React from "react";
import "./checkBoxCustom.css";

const CheckBoxCustom = ({
    checked,
    onChange,
    children,
    label,
    required = false,
    className = "",
    id,
}) => {
    const handleClick = () => {
        if (onChange) {
            onChange(!checked);
        }
    };

    return (
        <div className={"checkbox-custom " + className}>
            <div
                onClick={handleClick}
                className={
                    checked === true
                        ? "checkbox-custom__selector active"
                        : "checkbox-custom__selector"
                }
            >
                <div className="checkbox-custom__checkmark"></div>
            </div>
            <label className="checkbox-custom__label" onClick={handleClick}>
                {children || label}
                {required && (
                    <span className="checkbox-custom__required">*</span>
                )}
            </label>
        </div>
    );
};

export default CheckBoxCustom;
